import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { userRequest } from "../../utils/requestMethods";
import AlertNotification from "./AlertNotification";

const ROLE_LABELS = {
  teacher: "Teacher",
  burser: "Bursar",
  academic_admin: "Academic Admin",
};

const ROLE_MAP = {
  0: "admin",
  1: "teacher",
  2: "burser",
  3: "academic_admin",
  admin: "admin",
  teacher: "teacher",
  burser: "burser",
  academic_admin: "academic_admin",
};

const EditStaffNameModal = ({
  onClose,
  schoolId,
  staff,
  onUpdated,
  roleOptions,
  title = "Edit Name",
}) => {
  const [firstname, setFirstname] = useState(staff?.firstname || "");
  const [lastname, setLastname] = useState(staff?.lastname || "");
  const initialRole = ROLE_MAP[staff?.role] || staff?.role || (roleOptions && roleOptions[0]) || "";
  const [role, setRole] = useState(initialRole);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const payload = {
        firstname,
        lastname,
      };
      if (roleOptions?.length && role) {
        payload.role = role;
      }
      await userRequest.patch(`/schools/${schoolId}/staff/${staff._id}`, payload);
      onUpdated();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl w-full max-w-md p-6 shadow-lg relative">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 hover:bg-gray-200 text-2xl"
          >
            <MdClose />
          </button>
        </div>

        <form onSubmit={submitHandler} className="space-y-4">
          {error && <AlertNotification type="error" message={error} />}

          <div>
            <label className="block text-sm text-gray-600 mb-1">First Name</label>
            <input
              type="text"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
              placeholder="Enter first name"
              className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Last Name</label>
            <input
              type="text"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
              placeholder="Enter last name"
              className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              required
            />
          </div>

          {roleOptions?.length > 0 && (
            <div>
              <label className="block text-sm text-gray-600 mb-1">Role</label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                required
              >
                {roleOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {ROLE_LABELS[opt] || opt}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="mt-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#3F3DA5] text-white font-semibold rounded-full p-2 hover:bg-indigo-800 transition disabled:opacity-50"
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStaffNameModal;
